<template>
    <div class="relative flex flex-col justify-center items-center w-full text-gray-900">
        <div class="absolute w-full top-0 flex justify-center mt-6">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 218 94" class="fill-current h-24">
                <defs/>
                <path d="M55.1 2.4c-.7.8-.9 3-.5 5.8.7 5.1-1.4 9.9-10.9 25C32.8 50.4 7.2 83 1.9 86.3c-2.3 1.4-2.4 3.5-.3 5.8 1.5 1.6 1.9 1.5 6.7-2.1 8.8-6.7 20.5-12.7 32.2-16.6l11.2-3.7-1-3.3c-1-3.4-1.1-3.4-3.1-1.5C45.3 67 13 83.4 12.4 82.7c-.2-.2 5.3-7.8 12.2-16.8 23-29.8 36.4-50 36.4-54.6C61 9.2 57.5 1 56.6 1c-.2 0-.9.6-1.5 1.4zM206.8 26.7c-1.4 1.6-5.7 7.5-9.5 13.3-4.8 7.2-10.2 13.6-17.2 20.2-5.6 5.4-10.6 9.8-11.1 9.8-1.8 0-1.1-3.5 1.5-7.2 1.4-2 6.4-6.7 11.1-10.4 7.7-6 8.4-6.8 7-8.2-1.4-1.4-2.2-1.1-8.6 3.2-6.7 4.6-11.2 9.2-14.1 14.7-2.1 3.8-9.6 10.2-10.4 8.9-.7-1.1 3.1-7.7 6.8-11.7 1.9-2.1 1.9-2.4.4-4.1-1-1-1.7-2.6-1.7-3.5 0-.9-.7-1.7-1.5-1.7s-1.5.6-1.5 1.4c0 1.8-16 19.6-17.6 19.6-2.5 0-1.5-2.1 4.3-8.8 5.5-6.5 5.6-6.7 3.1-7-2.1-.2-4.2 1.4-11.1 8.2-4.7 4.8-9 8.6-9.6 8.6-5.2 0 8.8-16.2 17.3-20.1 2.3-1.1 2.9-1 3.6.1.7 1.2 1 1.2 1.6-.3 1-2.6-.3-4.7-2.8-4.7-5.9 0-18.7 10.8-26.5 22.3-3.5 5-5.9 6.3-4.7 2.4.9-2.9 5.1-11.2 7.9-15.8 1.5-2.4 2-4.1 1.4-5-.6-1.1-1.9-.4-5.6 3.4-2.7 2.6-5.2 4.7-5.6 4.7-.4 0-.7-1.1-.7-2.5 0-3.3-.7-3.2-4.7.7-3.7 3.6-4.8 3.4-3.3-.6.8-2.1.6-3.5-.6-6.1l-1.5-3.3-4.5 1.5c-3 1-7.4 4.2-13.3 9.7C76.8 66 65.1 74 62.3 74c-2.1 0-1.5-3.3 1.4-7.7 2.4-3.8 3-4.1 8-4.5 7.5-.6 13.6-6.4 11.3-10.8-2.4-4.5-8.6-3.2-14.8 3.1-2.8 2.8-3.2 3-3.2 1.3 0-1.1.5-2.5 1.2-3.2.6-.6.9-1.4.6-1.7-1.2-1.3-3.8 2.8-3.8 6 0 2-1.1 5-2.5 7.1-5 7.3-4.4 11.7 1.6 12.2 2.6.2 4.9-.7 9.7-3.7 5.9-3.9 6.2-4 6.2-1.8 0 3.2 2.7 6.7 5.2 6.7 4.1 0 10.8-4.2 15.4-9.6 2.6-3 5.5-5.4 6.5-5.4 2.4 0 2.4.6-.6 5.8-2.3 4.1-2.5 6.2-.5 6.2.5 0 3.1-3.2 6-7 2.8-3.9 5.5-6.8 6-6.5.5.3-.2 2.9-1.5 5.8-4.3 9.1-2.4 14.7 3.2 9.6 1.8-1.7 2.7-2 3-1.2.8 2.3 4 1.4 9.4-2.7 3-2.2 5.6-4 5.9-4 .3 0 .5 1.5.5 3.2 0 6 3.2 4.8 12.4-4.7 4.6-4.7 8.6-8.3 8.9-8 .3.2-.9 2.8-2.7 5.6-3.8 6.1-3.8 9.3 0 9.7 1.9.2 3.3-.5 5.2-2.7 3.1-3.7 3.5-3.8 3.9-.9.7 5.2 9.3 2.6 15.7-4.7 3.3-3.7 5.8-4.7 4.6-1.8-1.5 4-1.7 7.4-.5 8.8 2 2.4 2.5 1.8 2.6-3.3.1-7.2 6.1-17.8 19.4-34.7 3.5-4.4 5.9-8.3 5.6-9.1-.8-2.1-1.9-1.7-4.8 1.3zM79 54.5c0 1.7-3.7 4.4-6.9 5-3.2.6-2.6-2 1.2-4.4 3.8-2.4 5.7-2.7 5.7-.6zm19 4.1c0 4.3-.4 5.1-4.9 9.5-3.3 3.4-5.6 4.9-7.5 4.9-3.5 0-3.4-2.6.2-7.6C88.5 61.7 96.4 54 97.5 54c.3 0 .5 2.1.5 4.6zm3.6-.9c-1.1 1.1-1.9-.6-1.1-2.4.8-1.7.8-1.7 1.2 0 .3 1 .2 2.1-.1 2.4zM211.4 35c-1.5 2.2-2.4 4.3-2.1 4.6 1 1 8.1-6.2 7.3-7.4-1.2-2-2.5-1.3-5.2 2.8zM201.1 59.1c-6.9 7.3-10.1 11.3-9.4 12 .6.6 2.9-1.2 6.7-5.6 5.4-6 9.2-9.2 10.1-8.3.6.6-4.4 11.1-6.2 13-.9 1-2.5 1.8-3.6 1.8-1.6 0-1.7.3-.7 1.5 2.2 2.7 5.7 1.8 8.5-2.3 4.8-6.9 8.9-23.4 5.8-23.1-.4 0-5.5 5-11.2 11z"/>
            </svg>
        </div>
        <div class="relative flex flex-col md:flex-row items-center text-center text-2xl">
            <div class="mb-6 md:mb-0 md:absolute md:-ml-16">
                <font-awesome-icon icon="spinner" size="2x" pulse v-if="loading"></font-awesome-icon>
                <font-awesome-icon class="text-leonard-success" icon="check" size="2x" v-if="success && !loading"></font-awesome-icon>
                <font-awesome-icon class="text-leonard-error" icon="xmark" size="2x" v-if="!success && !loading"></font-awesome-icon>
            </div>
            <span class="font-bold">{{displayMessage}}</span>
        </div>
        <div class="absolute w-full bottom-0 mb-4 md:mb-24 flex flex-col md:flex-row justify-around items-center text-2xl" v-if="!loading">
            <button type="button" class="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 focus:border-b-2 border-blue-700 hover:border-blue-500 rounded" @click.prevent="returnToLogin">
                <font-awesome-icon class="mr-2" icon="arrow-left"></font-awesome-icon> Return To Login
            </button>
            <button type="button" class="bg-orange-500 hover:bg-orange-400 text-white font-bold py-2 px-4 border-b-4 focus:border-b-2 border-orange-700 hover:border-orange-500 rounded mt-8 md:mt-0" @click.prevent="retry" v-if="!success">
                <font-awesome-icon class="mr-2" icon="arrows-rotate"></font-awesome-icon> Try Again
            </button>
        </div>
    </div>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faSpinner, faCheck, faXmark, faArrowsRotate, faArrowLeft} from '@fortawesome/free-solid-svg-icons';

    import User from "./classes/User";

    export default {
        data() {
            return {
                User: new User(),
                id: null,
                email: null,
                signedUrl: null,
                displayMessage: "Loading...",
                loading: true,
                success: false,
            }
        },

        created() {
            library.add(faSpinner, faCheck, faXmark, faArrowsRotate, faArrowLeft);
        },

        mounted() {
            this.setUser();

            let self = this;
            window.addEventListener('load', function() {
                self.delay(self.checkVerified(), 500);
            })
        },

        updated() {
            console.log(this.displayMessage);
        },

        methods: {
            setSuccess(val) {
                this.success = val;
                return this;
            },

            setLoading(val) {
                this.loading = val;
                return this;
            },

            setDisplayMessage(val) {
                this.displayMessage = val;
                return this;
            },

            setUser() {
                try {
                    let path = window.location.pathname.split('/');
                    this.id = path[3];
                    this.email = path[4];
                    this.signedUrl = window.location.href;
                } catch (e) {
                    // catches a malformed URI
                    console.error('Error decoding email -', e);
                    this.setLoading(false);
                    this.setSuccess(false);
                    this.setDisplayMessage('Error: Email is invalid');
                }
            },

            checkVerified() {
                let self = this;
                let data = {
                    id: this.id,
                }

                this.setDisplayMessage('Checking...');

                this.User.checkVerified(data).then(function(response) {
                    if(!response.success) {
                        self.setLoading(false);
                        self.setSuccess(false);
                        self.setDisplayMessage('Error: An error occurred checking verification');

                        return;
                    }

                    if(response.message === 'Unverified' && response.data === null) {
                        self.delay(self.verify(), 500);
                        return;
                    }

                    self.setLoading(false);
                    self.setSuccess(true);
                    self.setDisplayMessage('Already Verified!');
                });
            },

            verify() {
                let self = this;
                let data = {
                    id: this.id,
                    emailAddress: this.email,
                    signedUrl: this.signedUrl,
                }

                this.setDisplayMessage('Verification in progress...');

                this.User.verify(data).then(function(response) {
                    if(!response.success) {
                        self.setLoading(false);
                        self.setSuccess(false);
                        self.setDisplayMessage('Error: An error occurred during verification');

                        return;
                    }

                    self.setLoading(false);
                    self.setSuccess(true);
                    self.setDisplayMessage('Verified!');
                });
            },

            retry() {
                this.setLoading(true);
                this.setDisplayMessage('Retrying...');
                this.delay(this.checkVerified(), 750);
            },

            returnToLogin() {
                window.location.href = window.location.origin + '/login';
            }
        }
    }
</script>
